// Toast Yapılandırması
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const centerToast = Swal.mixin({
  position: "center",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  icon: "success",
});

function showCenterToast(message) {
  centerToast.fire({
    title: message,
  });
}

function showToast(type, message) {
  Toast.fire({
    icon: type,
    title: message,
  });
}


// product sayfasi custom color kismi editleme

function applyRalLabels() {
    document.querySelectorAll('.main-product__block .m-product-option--node__label').forEach((label) => {

        if (label.nextElementSibling?.classList.contains('color-label')) return;

        const colorValue = label.style.backgroundColor;
        if (!colorValue) return;

        let ralText = "";

        if (colorValue.includes("74, 77, 79")) {
            ralText = "RAL7016";
        } else if (colorValue.includes("213, 205, 190")) {
            ralText = "RAL9001";
        } else if (colorValue.includes("255, 255, 255")) {
            ralText = "RAL9010";
        } else if (colorValue.includes("15, 15, 15")) {
            ralText = "RAL9005";
        }

        if (ralText) {
            label.insertAdjacentHTML(
                'afterend',
                `<span class="color-label">${ralText}</span>`
            );
        }
    });
}

// ilk yükleme
document.addEventListener("DOMContentLoaded", applyRalLabels);

// URL (variant) değişimini yakala
(function () {
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    function onUrlChange() {
        applyRalLabels();
    }

    history.pushState = function () {
        pushState.apply(history, arguments);
        onUrlChange();
    };

    history.replaceState = function () {
        replaceState.apply(history, arguments);
        onUrlChange();
    };

    window.addEventListener("popstate", onUrlChange);
})();